<template>
    <div class="DebugMode">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>DEBUG :: 도메인 리스트</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                    <img src="@/assets/images/btn_close.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <div>
                <!-- s: Alarm 리스트 -->
                <ul class="li-bottom-line">
                    <li v-for="(data, index) in list" :key="index">
                        <h3 @click="funServerChangServer(data.srrDomain)">
                            {{ data.strLabel }}
                        </h3>
                    </li>
                </ul>
                <!-- e: Alarm 리스트 -->
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>


export default {
    name: 'DebugMode',
    data() {
        return {
            list:[]
        }
    },
    // 감시자
    watch: {
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.changeDomainInfoList();
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // Alarm 리스트 호출
        changeDomainInfoList(){
            let param = {};
            this.ajaxGetAuth('/api/v1/admin/changeDomainInfo', param, this.changeDomainInfoListResult);
        },
        // Alarm 리스트 결과
        changeDomainInfoListResult(response){
            if (response.result.code == 0){
                this.list = response.oAdmin.list;
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
    }
}
</script>

<style scoped>
    .btn-alarm-read{position: absolute;top: 8px;right: 15px;background: #2e9cff;color: #fff;border: 0;padding: 5px 10px;font-size: 16px;border-radius: 5px;}
    .li-bottom-line div{padding-left: 45px;background-repeat: no-repeat; background-position: center left; background-size: 38px 53px; }
    .li-bottom-line div.icon-note.on{background-image: url("../../assets/images/icon_note_on.png");}
    .li-bottom-line div.icon-note.off{background-image: url("../../assets/images/icon_note_off.png");}
    .li-bottom-line div.icon-reply.on{background-image: url("../../assets/images/icon_reply_on.png");}
    .li-bottom-line div.icon-reply.off{background-image: url("../../assets/images/icon_reply_off.png");}

    .li-bottom-line div h3{font-size: 13px; font-weight: 400; color: #737373;}
    .li-bottom-line div h2{font-size: 16px; font-weight: 500; color: #737373;text-decoration: none;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;}

    .li-bottom-line div.on h3{color: #000;}
    .li-bottom-line div.on h2{color: #000;}
</style>
